import { Champion as ChampionDto } from '@electricjs/core_entity-client';
import { ChampionResponse } from '@/types/requests';

export const organizationApplicationChampionsList: ChampionDto[] = [
  {
    id: 'champion-id-1',
    employee_id: 'simple-employee-id',
  },
  {
    id: 'champion-id-2',
    employee_id: 'simple-employee-id',
  },
  {
    id: 'champion-id-3',
    employee_id: 'simple-employee-id',
  },
];

// The one app whose bulk champions include a visible and a restricted champion,
// so other flows that read the same endpoint keep seeing no champions.
export const MOCK_APP_SLUG_WITH_RESTRICTED_CHAMPION = 'slack';

export const createOrganizationApplicationChampion = {
  id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  employee_id: 'test',
};

export const createTestChampion = (
  overrides: Partial<ChampionResponse> = {}
): ChampionResponse => ({
  id: 'champ-1',
  employeeId: 'emp-1',
  rank: 0,
  ...overrides,
});
